import instanceQuery from '../../../graphql/queries/purchases/PurchaseOrderCancelReceiptQuery.graphql';
import mutationQuery from '../../../graphql/mutations/purchases/PurchaseOrderCancelReceipt.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseOrderCancelReceipt: EntityType = {
  type: 'purchaseOrderReceiptAdjustment',
  title: 'Purchase Order Receipt Cancellation',
  formTitle: 'Purchase Order Receipt Cancellation',
  formUrl: '/Purchasing/CancelReceipt/Details/',
  instance: instanceQuery,
  update: mutationQuery,
  permissionLabel: 'Cancel Receipts',
  screenReference: 'PURCHASE_CANCEL_RECEIPT',
};

export default PurchaseOrderCancelReceipt;
